import { useSpin } from '@/api/lucky-spins/mutations/useSpin';
import { useLuckySpinWithSelectedSpin } from '@/hooks/useLuckySpinWithSelectedSpin';
import { RootState } from '@/lib/store';
import { LuckySpinStatus } from '@/models/userReward/lucky-spin/enums/lucky-spin-status';
import { AuthService } from '@/services/AuthService';
import { Button } from '@starsoft/common/components';
import useTranslation from 'next-translate/useTranslation';
import { useSelector } from 'react-redux';

import { getContrastColor } from '@/utils/color/getContrastColor';
import { parseToBigInt } from '@starsoft/common/utils/parsers';
import Color from 'color';
import styles from './styles.module.scss';

export default function RouletteButton() {
  const { t, lang } = useTranslation('common');
  const { isLoading, luckySpin, mode } = useLuckySpinWithSelectedSpin();
  const { spin, isLoading: loadingMutation } = useSpin();

  const isSpinning: boolean = useSelector(
    (state: RootState) => state.luckSpin.isSpinning,
  );

  function handleSpin() {
    spin({
      luckySpinId: parseToBigInt(mode) as bigint,
    });
  }

  const isDisabled: boolean = loadingMutation || isSpinning;

  const cantPlay: boolean =
    luckySpin?.status && luckySpin?.status != LuckySpinStatus.Spinnable;

  return (
    <div
      className={styles.button__container}
      style={{
        //@ts-ignore
        '--button-color': Color(luckySpin?.rankGroup?.color)
          .desaturate(-2)
          .toString(),
      }}
    >
      <Button
        disabled={!AuthService.isAuthorized() || cantPlay}
        isloading={isDisabled}
        isSkeleton={isLoading}
        onClick={handleSpin}
        className={styles.button}
        textColor={getContrastColor(String(luckySpin?.rankGroup?.color))}
      >
        {!cantPlay
          ? t('spin')
          : t('disabled_button_text', {
              level: luckySpin?.rankGroup?.name?.[lang],
            })}
      </Button>
    </div>
  );
}
